/**
 * @generated SignedSource<<804faa69ee3724a3231baa39cda7f80f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "dynamicVocab" | "enhancedText" | "file" | "globalVocab" | "markMistakes" | "matrix" | "multipleChoice" | "order" | "podcast" | "podcastWithTimestamp" | "text" | "video";
import { FragmentRefs } from "relay-runtime";
export type GoToPreviousElementButton_ContentSubmissionFragment$data = {
  readonly definition: {
    readonly canGoToPrevious?: boolean;
    readonly currentElementState?: {
      readonly element: {
        readonly elementType: ElementTypeV2;
        readonly id: string;
      };
    } | null;
  };
  readonly id: string;
  readonly " $fragmentType": "GoToPreviousElementButton_ContentSubmissionFragment";
};
export type GoToPreviousElementButton_ContentSubmissionFragment$key = {
  readonly " $data"?: GoToPreviousElementButton_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoToPreviousElementButton_ContentSubmissionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoToPreviousElementButton_ContentSubmissionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "currentElementState",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "elementType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "canGoToPrevious",
              "storageKey": null
            }
          ],
          "type": "ActiveELearningContentSubmissionDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};
})();

(node as any).hash = "af45011c08e503405c67549c62a1fc81";

export default node;
